<template>
<div>
<main v-if="tenantLoginType === 'vas'" class="error-page-404 area remove-body-top-padding">
    <div class="vr start">
      <div class="glasses content">
        <h2 class="message" v-html="$t('messages.404.description')" />
        <div class="lines">
          <div />
          <div />
          <div />
        </div>
      </div>
    </div>
    <div class="vr end">
      <div class="glasses content">
        <h1 class="error-404">
          404
        </h1>
      </div>
    </div>
  </main>
<div v-if="tenantLoginType === 'organic'">
<AppHeader />
<div class="remove-body-top-padding bg-404 d-flex justify-self-center w-100 h-100">
    <lottie :options="defaultOptions" v-on:animCreated="handleAnimation"/>
</div>
</div>
</div>
</template>

<script>
  import Lottie from 'vue-lottie';
  import * as animationData from '@/assets/404.json';
  import PortalInitialization from "@/components/PortalInitialization";
  import AppHeader from "@/components/Header";
  import { mapGetters, mapActions } from "vuex";
export default {
  name: 'Error404',
  components: {
      'lottie': Lottie,
      PortalInitialization,
      AppHeader
    },
    data() {
      return {
        defaultOptions: {animationData: animationData.default},
        animationSpeed: 1
      }
    },
    computed: {
      ...mapGetters({
        portalConfigurations: "tenantConfig/config",
        tenantDesignConfig: 'tenantDesign/config',
      }),
      portalGeneralInfo() {
        return this.portalConfigurations.general;
      },
      tenantLoginType () {
      return this.tenantDesignConfig.userManagement.loginType.toLowerCase()
    },
    },
    methods: {
      ...mapActions({
          init: 'auth/init',
      }),
      handleAnimation: function (anim) {
        this.anim = anim;
      }
    },
    created() {
      this.init()
    },
}
</script>

